import Btn from '../utils/btn';

const func = $target => {
	var $token = $target.data('token'),
		siteUrl = $target.data('site-url'),
		$loadingContainer = $target.find('.loading-container'),
		$chatWindow = $target.find('[data-id="chat-window"]'),
		$chatMessages = $chatWindow.find('ul'),
		$cases = $target.find('[data-id="cases"]'),
		$myChat = $target.find('[data-id="my-chat"]'),
		$channelId = $target.data('cid'),
		$messageInput = $target.find('[data-id="message-input"]'),
		$searchInput = $target.find('[data-id="search-input"]'),
		$numMembersOnline = $target.find('[data-id="num-members-online"]'),
		$membersOnline = $target.find('[data-id="members-online"]'),
		$inviteModal = $target.find('#inviteModal'),
		$newEmailForm = $inviteModal.find('[data-id="new-email-form"]'),
		$inviteEmails = $inviteModal.find('[data-id="invite-emails"]'),
		$inviteForm = $inviteModal.find('[data-id="invite-form"]'),
		$teamModal = $target.find('#teamModal'),
		$selectTeamForm = $teamModal.find('[data-id="select-team-form"]'),
		$teamNames = $teamModal.find('[data-id="team-names"]'),
		$teamForm = $teamModal.find('[data-id="team-form"]'),
		$sideBarToggleBtn = $target.find('[data-id="sidebar-toggle"]'),
		$sidebar = $($sideBarToggleBtn.data('target')),
		$content = $target.find('[data-id="content"]'),
		$mainCol = $('[data-id="main-col"]'),
		$galleryModal = $target.find('#galleryModal'),
		$videoModal = $target.find('#videoModal'),
		chatClient,
		activeChannelPage;

	if ($token) {
		window.loader.keys(['twilio', 'moment'], function () {
			// console.log('twilio loaded');

			// Initialize the Chat client
			Twilio.Chat.Client.create($token)
				.then(client => {
					chatClient = client;

					console.log('Created chat client');
					console.log('Reachabiliy: ' + chatClient.reachabilityEnabled);

					setupSidebarChannels();
					if ($channelId) {
						setupChannel();
					}
					channelSearch();

					chatClient.on('channelUpdated', updateChannelNewMessages);

					chatClient.user.on('updated', function (event) {
						console.log(event.user.identity + ' user updated');

						var $member = $membersOnline.find('[data-user-identity="' + event.user.friendlyName + '"] small');

						if (event.user.online) {
							$member.addClass('online');
						} else {
							$member.removeClass('online');
						}
					});
				})
				.catch(error => {
					console.error(error);
				});

			function setupSidebarChannels() {
				chatClient.getSubscribedChannels().then(page => {
					console.log('No. of user channels:' + page.items.length);

					var subscribedChannels = page.items.sort(function (a, b) {
						return (a.lastMessage ? a.lastMessage.timestamp : a.dateUpdated) < (b.lastMessage ? b.lastMessage.timestamp : b.dateUpdated) ? 1 : -1;
					});

					// console.log(subscribedChannels);

					var $targets = {
						support: $('[data-id="support"]'),
						chat: $('[data-id="messages"]'),
						case: $('[data-id="cases"]'),
					};

					var $unread = {
						chat: [],
						case: [],
					};

					// add user channels to sidebar
					$.each(subscribedChannels, function () {

						var channel = this,
							$li, patientName;
						if (channel.attributes.type == 'chat') {
							$li = $(`<li data-id="${channel.sid}" data-updated="${(channel.lastMessage ? channel.lastMessage.timestamp : channel.dateUpdated).toISOString()}"></li>`);
							patientName = '';
							if (channel.attributes.patientName) {
								patientName = '<br><span class="text-custom1">' + this.attributes.patientName + '</span>';
							}
							$li.html(`
									<a href="${siteUrl}account/chat/?cid=${channel.sid}" class="d-block border-bottom ` + ($channelId == channel.sid ? ' active' : '') + `">
										${channel.friendlyName.toUpperCase()}
										<small>${patientName}</small>
										<span data-id="unread" class="float-right"></span>
									</a>`);
							$myChat.append($li);
						}
						if (channel.attributes.type == 'case') {
							$li = $(`<li data-id="${channel.sid}" data-updated="${(channel.lastMessage ? channel.lastMessage.timestamp : channel.dateUpdated).toISOString()}"></li>`);
							patientName = '';
							if (channel.attributes.patientName) {
								patientName = '<br><span class="text-custom1">' + this.attributes.patientName + '</span>';
							}
							$li.html(`
									<a href="${siteUrl}account/chat/?cid=${channel.sid}" class="d-block border-bottom ` + ($channelId == channel.sid ? ' active' : '') + `">
										${channel.friendlyName.toUpperCase()}
										<small>${patientName}</small>
										<span data-id="unread" class="float-right"></span>
									</a>`);
							$cases.append($li);
						}
						if (channel.attributes.type == 'support') {
							$target.find('[data-id="support-tab"]').attr('href', `${siteUrl}account/chat?cid=` + channel.sid);
						}

						channel.getUnconsumedMessagesCount().then(
							function (value) {

								/*var chatType = $cases,
									html,
									$supportTab = $target.find('[data-id="support-tab"]'),
									patientName = '';
*/
								/*if (this.attributes.type == 'chat') {
									chatType = $myChat;
								}*/

								/*if (this.attributes.type == 'support') {
									$supportTab.attr('href', '/account/chat?cid=' + this.sid);
									chatType = '';
								}*/

								if (channel.attributes.type == 'case' || channel.attributes.type == 'chat') {
									/*if (this.attributes.patientName) {
										patientName = '<br><span class="text-custom1">' + this.attributes.patientName + '</span>';
									}

									// if(this.sid)

									html = '<li data-unread="' + value + '" data-id="' + this.sid + '"><a href="/account/chat?cid=' + this.sid + '" class="d-block border-bottom ' + ($channelId == this.sid ? 'active' : '') + '">' + this.friendlyName.toUpperCase() + '<small>' + patientName + '</small><span class="float-right">';
*//*
																																																																																																																																																if (value > 0) {
																																																																																																																																																	html += '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 50 50"> \
																																																																																																																																																	<circle cx="25" cy="25" r="25" class="fill-success"></circle> \
																																																																																																																																																	<text x="50%" y="53%" font-size="20" dominant-baseline="middle" text-anchor="middle" class="fill-light">' + value + '</text> \
																																																																																																																																																</svg>';
																																																																																																																																																}
																																																																																																																																							
																																																																																																																																																html += '</span></a></li>';
																																																																																																																																							
																																																																																																																																																chatType.append(html);
																																																																																																																																							
																																																																																																																																																chatType
																																																																																																																																																	.find('li')
																																																																																																																																																	.sort(sortLi)
																																																																																																																																																	.appendTo(chatType);
																																																																																																																																							*/
									if (value > 0) {
										$unread.chat.push($(`li[data-id="${this.sid}"]`));
										$(`li[data-id="${this.sid}"]`).find('span[data-id="unread"]').append(`<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 50 50">
											<circle cx="25" cy="25" r="25" class="fill-success"></circle>
											<text x="50%" y="53%" font-size="20" dominant-baseline="middle" text-anchor="middle" class="fill-light">${value}</text>
										</svg>`);

										$unread.chat = $unread.chat.sort(function (a, b) {
											return new Date(a.attr('data-updated')) > new Date(b.attr('data-updated')) ? 1 : -1;
										});
										$.each($unread.chat, function () {
											if (channel.attributes.type == 'case') {
												$cases.prepend(this);
											} else {
												$myChat.prepend(this);
											}
										})
									}
								}

								/*function sortLi(a, b) {
									return $(b).data('unread') > $(a).data('unread') ? 1 : -1;
								}*/
							}.bind(channel)
						);
					});
				});
			}

			function setupChannel() {
				chatClient.getChannelBySid($channelId).then(function (channel) {
					var caseChannel = channel;

					getMessages(caseChannel);
					sendMessage(caseChannel);
					updateConsumption(caseChannel);

					caseChannel.getMembers().then(countOnlineMembers);
					caseChannel.on('messageAdded', addMessage);

					//dragDrop(caseChannel);
					galleryPicker(caseChannel);

					// caseChannel.on('typingStarted', function(member) {
					// 	console.log(member.identity + 'is currently typing.');
					// });

					// caseChannel.on('memberJoined', function(member) {
					// 	console.log(member.identity + 'has joined the channel.');
					// });
				});
			}

			function updateChannelNewMessages(event) {
				var updatedChannel = event.channel;
				console.log('get updates')

				event.updateReasons.forEach(function (reason) {
					console.log(reason)
					if (reason == 'lastMessage') {
						updatedChannel.getUnconsumedMessagesCount().then(function (value) {
							console.log('getUnconsumedMessagesCount: ', value);

							var $channel = $('[data-id="sidebar"] [data-id="' + updatedChannel.sid + '"]');

							var html = '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 50 50" class="float-right"> \
									<circle cx="25" cy="25" r="25" class="fill-success"></circle> \
									<text x="50%" y="53%" font-size="20" dominant-baseline="middle" text-anchor="middle" class="fill-light">' + value + '</text> \
								</svg>';
							console.log(html)
							$channel.find('[data-id="unread"]').html(html);
							console.log($channel)
							console.log(updatedChannel.attributes.type)

							if (updatedChannel.attributes.type == 'chat') {
								$channel.prependTo($('[data-id="messages"]'));
							}
							if (updatedChannel.attributes.type == 'case') {
								$channel.prependTo($('[data-id="cases"]'));
							}
						});
					}
				});
			}

			function getMessages(channel) {
				channel.getMessages(30).then(function (page) {
					activeChannelPage = page;

					$loadingContainer.addClass('loading');

					page.items.forEach(addMessage);

					// channel.on('messageUpdated', updateMessage);
					// channel.on('messageRemoved', removeMessage);

					var newestMessageIndex = page.items.length ? page.items[page.items.length - 1].index : 0;
					var lastIndex = channel.lastConsumedMessageIndex;
					if (lastIndex && lastIndex !== newestMessageIndex) {
						var $li = $('li[data-index=' + lastIndex + ']'),
							top = $li.position() && $li.position().top;

						$li.addClass('last-read');
						$chatWindow.scrollTop(top + $chatWindow.scrollTop());
					}

					if ($chatMessages.height() <= $chatWindow.height()) {
						channel.updateLastConsumedMessageIndex(newestMessageIndex).then();
					}

					$loadingContainer.removeClass('loading');
				});
			}

			function addMessage(message) {
				var messageContent = '',
					initHeight = $chatMessages.height();

				if (message.type === 'media') {
					message.media.getContentUrl().then(
						function (url) {
							if (message.media.contentType.indexOf('image') !== -1) {
								// messageContent = '<a href="' + url + '" data-toggle="modal" data-target="#assetModal" role="button" aria-expanded="false" aria-controls="assetModal"><img src="' + url + '" class="img-fluid gallery-image"></a>';
								messageContent = '<a href="/account/chat/image?uid=' + message.attributes.assetUid + '&cid=' + $channelId + '" target="_blank"><img src="' + url + '" class="img-fluid gallery-image"><a>';
							} else {
								messageContent = '<a href="' + url + '" target="_blank"><img src="/assets/img/file-icon.svg" class="img-fluid file">   <span>' + message.media.filename + '</span></a>';
							}

							$chatMessages.find('[data-index="' + message.index + '"] .media-body').replaceWith(messageContent);
						}.bind(message)
					);
				} else {
					messageContent = '<p>' + message.body + '</p>';
				}

				printMessage(message, messageContent);

				if (initHeight - 50 < $chatWindow.scrollTop() + $chatWindow.height()) {
					$chatWindow.scrollTop($chatMessages.height());
				}

				if ($chatMessages.height() <= $chatWindow.height() && message.index > message.channel.lastConsumedMessageIndex) {
					message.channel.updateLastConsumedMessageIndex(message.index);
					console.log('updateLastConsumedMessageIndex');
				}

				// if(message.memberSid == message.channel) {

				// }
			}

			function printMessage(message, messageContent, prepend = false) {
				message.getMember().then(function (member) {
					member.getUser().then(
						function (user) {
							var memberFriendlyName = user.friendlyName,
								initials = memberFriendlyName.match(/\b\w/g) || [],
								$memberMessages = $chatWindow.find('[data-membersid="' + this.sid + '"]'),
								profileHtml;

							initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();

							$memberMessages.find('[data-id="friendlyName"]').text(memberFriendlyName);

							if (user.attributes.profileImage) {
								profileHtml = '<img src="/images/' + user.attributes.profileImage + '" class="mr-2">';
							} else {
								profileHtml = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" class="mr-2"> \
								<circle cx="25" cy="25" r="25"></circle> \
								<text x="50%" y="53%" font-size="18" dominant-baseline="middle" text-anchor="middle" data-id="initials">' + initials + '</text> \
								</svg>';
							}

							$memberMessages.find('[data-id="profile"]').html(profileHtml);
						}.bind(member)
					);
				}).catch(function(){

				});

				var profileHtml = '',
				messageFriendlyName = '';

			if(message.attributes.friendlyName) {
				var initials = message.attributes.friendlyName.match(/\b\w/g) || [];
				initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
				profileHtml = '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" class="mr-2"> \
							<circle cx="25" cy="25" r="25"></circle> \
							<text x="50%" y="53%" font-size="18" dominant-baseline="middle" text-anchor="middle" data-id="initials">' + initials + '</text> \
							</svg>';
				
				messageFriendlyName = message.attributes.friendlyName;
			}

			var html =
				'<li data-index="' +
				message.index +
				'" data-membersid="' +
				message.memberSid +
				'"><div class="card border-0 p-3"> \
				<div class="card-header p-0 border-0 bg-white"> \
					<div class="d-flex align-items-center"> \
					<span data-id="profile">'+ profileHtml +'</span><span><span data-id="friendlyName"> ' + messageFriendlyName + '</span> <span class="text-muted small text-nowrap">| ' +
				moment(message.timestamp).format('ddd MMM DD Y HH:mm:ss ([GMT] ZZ)') +
				'</span></span> \
					</div> \
				</div> \
				<div class="card-body p-0 last-child-mb-0 font-size-95"> \
				<div class="media"> \
					<div class="media-body"> \
							' +
				messageContent +
				' \
						</div> \
					</div> \
				</div> \
			</div></li>';

				if (prepend) {
					$chatMessages.prepend(html);
				} else {
					$chatMessages.append(html);
					setTimeout(function () {
						$chatWindow.scrollTop($chatWindow[0].scrollHeight);
					}, 1000);
				}

				// $chatWindow.scrollTop($chatWindow[0].scrollHeight);
			}

			function sendMessage(channel) {
				//console.log($messageInput[0]);
				//console.log($messageInput.parent().css('display'))
				$messageInput.on('focus', function (e) {
					// if ($messageInput.parent().css('display') == 'block') {
					$(this).attr('rows', 4);
					// }
				}).on('blur', function (e) {
					$(this).attr('rows', 1);
				})

				$messageInput.on('keypress', function (e) {
					var $this = $(this);

					if (e.keyCode == 13 && $(this).val()) {
						channel.sendMessage($(this).val(),{'friendlyName':chatClient.user.friendlyName});
						$this.val('');
						setTimeout(function () {
							$this.val('');
						}, 50);
					} else {
						// TODO debounce/throttle
						channel.typing();
					}
				});
			}

			function sendMedia(channel, uid) {
				$loadingContainer.addClass('loading');

				$.ajax({
					url: '/actions/twilio/chat/get-asset-info',
					dataType: 'json',
					data: { assetUid: uid }
				}).done(function (data) {
					console.log('Filename:' + data.filename);

					var binary = fixBinary(atob(data.encodedAsset)),
						blob = new Blob([binary], { type: data.mimeType });

					const formData = new FormData();
					formData.append('file', blob, data.filename);
					channel.sendMessage(formData, { 'assetUid': data.uid }).then(function () {
						$loadingContainer.removeClass('loading');
					});
				});
			}

			function galleryPicker(channel) {
				var $close = $galleryModal.find('.close');
				$galleryModal.find('.modal-body a[data-uid]').on('click', function (e) {
					e.preventDefault();
					sendMedia(channel, $(this).attr('data-uid'));
					$close.trigger('click');
				})
			}

			function dragDrop(channel) {
				interact('[data-uid]').draggable({
					// enable inertial throwing
					inertia: true,
					// keep the element within the area of it's parent
					modifiers: [
						interact.modifiers.restrictRect({
							// restriction: 'parent',
							endOnly: true
						})
					],
					// enable autoScroll
					autoScroll: true,

					// call this function on every dragmove event
					onmove: dragMoveListener
					// call this function on every dragend event
					// onend: function (event) {
					// 	var textEl = event.target.querySelector('p')

					// 	textEl && (textEl.textContent =
					// 		'moved a distance of ' +
					// 		(Math.sqrt(Math.pow(event.pageX - event.x0, 2) +
					// 				Math.pow(event.pageY - event.y0, 2) | 0))
					// 		.toFixed(2) + 'px')
					// }
				});

				interact('.loading-container').dropzone({
					// only accept elements matching this CSS selector
					accept: '[data-uid]',
					// Require a 75% element overlap for a drop to be possible
					overlap: 0.75,

					// listen for drop related events:

					ondropactivate: function (event) {
						// add active dropzone feedback
						event.target.classList.add('drop-active');
						console.log('active');
					},
					// ondragenter: function (event) {
					// 	console.log('enter');
					// },
					// ondragleave: function (event) {
					// 	console.log('leave');
					// },
					ondrop: function (event) {
						sendMedia(channel, event.relatedTarget.getAttribute('data-uid'));
						console.log('ondrop');
					},
					ondropdeactivate: function (event) {
						// remove active dropzone feedback
						event.target.classList.remove('drop-active');
						console.log('ondropdeactivate');

						var target = event.relatedTarget;

						target.style.webkitTransform = target.style.transform = 'translate(0px, 0px)';

						target.setAttribute('data-x', 0);
						target.setAttribute('data-y', 0);
					}
				});

				function dragMoveListener(event) {
					var target = event.target;
					// keep the dragged position in the data-x/data-y attributes
					var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
					var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

					// translate the element
					target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

					// update the posiion attributes
					target.setAttribute('data-x', x);
					target.setAttribute('data-y', y);
				}
			}

			function countOnlineMembers(members) {
				var totalMembersOnline = 0,
					memberCount = 0;

				console.log($numMembersOnline);

				members.forEach(member => {
					member.getUserDescriptor().then(function (userDescriptor) {
						if (userDescriptor.online) {
							console.log(userDescriptor.friendlyName);

							$membersOnline.prepend('<li class="p-1 pl-2" data-user-identity="' + userDescriptor.friendlyName + '"><small class="online">' + userDescriptor.friendlyName + '</small></li>');

							totalMembersOnline++;
						} else {
							$membersOnline.append('<li class="p-1 pl-2" data-user-identity="' + userDescriptor.friendlyName + '"><small>' + userDescriptor.friendlyName + '</small></li>');
						}

						memberCount++;
						if (memberCount == members.length) {
							//update span
							$numMembersOnline.text(totalMembersOnline);
						}
					});
				});
			}

			function updateConsumption(channel) {
				var isUpdatingConsumption = false;

				$chatWindow.on('scroll', function (e) {
					var $this = $(this);

					if ($chatMessages.height() - 50 < $chatWindow.scrollTop() + $chatWindow.height()) {
						channel.getMessages(1).then(function (messages) {
							var newestMessageIndex = messages.items.length ? messages.items[0].index : 0;

							if (!isUpdatingConsumption && channel.lastConsumedMessageIndex !== newestMessageIndex) {
								isUpdatingConsumption = true;
								channel.updateLastConsumedMessageIndex(newestMessageIndex).then(function () {
									isUpdatingConsumption = false;
								});
							}
						});
					}

					if ($chatWindow.scrollTop() < 50 && activeChannelPage && activeChannelPage.hasPrevPage && !$this.hasClass('loader')) {
						$this.addClass('loader');
						var initialHeight = $('ul', $this).height();

						activeChannelPage.prevPage().then(page => {
							var difference = $('ul', $this).height() - initialHeight;

							page.items.reverse().forEach(prependMessage);
							activeChannelPage = page;

							$this.scrollTop(difference);
							$this.removeClass('loader');
						});
					}
				});
			}

			function prependMessage(message) {
				var messageContent;

				if (message.type === 'media') {
					message.media.getContentUrl().then(
						function (url) {
							messageContent = '<img src="' + url + '" class="img-fluid">';
							printMessage(this, messageContent, true);
						}.bind(message)
					);
				} else {
					messageContent = '<p>' + message.body + '</p>';
					printMessage(message, messageContent, true);
				}
			}

			// user invite
			$newEmailForm.on('submit', function (e) {
				e.preventDefault();

				var $this = $(this),
					$email = $this.find('[name="email"]'),
					$submit = new Btn($this.find('button[type="submit"]')),
					$emails = $inviteForm.find($('input[value="' + $email + '"]'));

				if ($emails[0] === undefined) {
					$inviteEmails.append('<div data-id="' + $email.val() + '"><small>' + $email.val() + '</small> <a href="#" data-type="remove">X</a> </div>');
					$inviteForm.append('<input type="hidden" name="emails[]" value="' + $email.val() + '">');
				}
				$email.val('');

				$inviteForm.find('button[type="submit"]').removeAttr('disabled');

				$submit.processed();
			});

			// team invite
			$selectTeamForm.on('submit', function (e) {
				e.preventDefault();

				var $this = $(this),
					$team = $this.find('[name="team"]'),
					$selectedTeam = $this.find(':selected'),
					$submit = new Btn($this.find('button[type="submit"]')),
					$teamIds = $teamForm.find($('input[value="' + $selectedTeam + '"]'));

				if ($teamIds[0] === undefined) {
					$teamNames.append('<div data-id="' + $selectedTeam.val() + '"><small>' + $selectedTeam.text() + '</small> <a href="#" data-type="remove">X</a> </div>');
					$teamForm.append('<input type="hidden" name="teamIds[]" value="' + $selectedTeam.val() + '">');
				}

				$team.prop('selectedIndex', 0);

				$teamForm.find('button[type="submit"]').removeAttr('disabled');

				$submit.processed();
			});

			// delete user/teams added to invite lists
			$('[data-id="invite-emails"],[data-id="team-names"]').on('click', '[data-type="remove"]', function (e) {
				e.preventDefault();

				var $this = $(this),
					$id = $this.closest('div').data('id'),
					num = $this.closest('[data-id="invite-emails"],[data-id="team-names"]').find('[data-type="remove"]').length;

				if (num - 1 == 0) {
					// console.log($this.closest('.modal-content').find('.modal-footer'));
					$this
						.closest('.modal-content')
						.find('.modal-footer button[type="submit"]')
						.prop('disabled', true);
				}

				$target.find($('input[value="' + $id + '"]')).remove();
				$target.find('[data-id="' + $id + '"]').remove();
			});

			// upload media
			$('input[type=file]')
				.change(function (e) {
					var files = [];
					for (var i = 0; i < $(this)[0].files.length; i++) {
						files.push($(this)[0].files[i].name);
					}
					var $label = $(this).next('.custom-file-label');
					if (!$label.data('default')) {
						$label.data($label.html());
					}
					if (files.length) {
						$label.html(files.join(', '));
						$(this).trigger('blur');
						$(this)
							.closest('form')
							.addClass('loading')
							.submit();
					} else {
						$label.html($label.data('default'));
					}
					//
				})
				.trigger('change');

			function fixBinary(bin) {
				// convert base64/URLEncoded data component to raw binary data held in a string
				var length = bin.length,
					buf = new ArrayBuffer(length),
					arr = new Uint8Array(buf);

				// write the bytes of the string to a typed array
				for (var i = 0; i < length; i++) {
					arr[i] = bin.charCodeAt(i);
				}

				return buf;
			}

			function channelSearch() {

				$searchInput.closest('form').on('submit', function (e) {
					e.preventDefault();
				})

				$searchInput.on('keyup', function (e) {
					var $this = $(this),
						$searchValue = $this.val();

					$searchValue = $searchValue.toLowerCase().replace(/\b[a-z]/g, function (letter) {
						return letter.toUpperCase();
					});

					if ($searchValue == '') {
						$('[data-id="cases"] > li').show();
					} else {
						$('[data-id="cases"] > li:not(:contains(' + $searchValue + '))').hide();
						$('[data-id="cases"] > li:contains(' + $searchValue + ')').show();
					}
				});
			}

			$('#assetModal').on('show.bs.modal', function (event) {
				var button = $(event.relatedTarget);
				$(this)
					.find('#assetModalImage')
					.attr('src', button.attr('href'));
			});

			//console.log(document.location.hash)
			if (document.location.hash == '#gallery') {
				$('#galleryModal').modal('show');
			}
			if (document.location.hash == '#annotations') {
				$('#annotationModal').modal('show');
			}

			/* VIDEO */

			console.log(Twilio.Video)
			// Twilio.Video.isSupported




			var activeRoom;
			var previewTracks;
			var identity;


			$('#videoModal').on('show.bs.modal', function (event) {
				var button = $(event.relatedTarget);
				var $modal = $(this),
					$modalBody = $modal.find('.modal-body');

				if (Twilio.Video.isSupported) {
					$modal.find('#unsupportedBrowser').remove();

					$modalBody.attr('data-total', 0);

					Twilio.Video.createLocalTracks().then(tracks => {
						var previewContainer = getParticipantContainer($modal, 'local');
						//if (!previewContainer.find('video')[0]) {
						previewTracks = tracks;
						attachTracks(tracks, previewContainer);
						updateParticipantTotal(1, $modalBody)
						//}


						Twilio.Video.connect($token, { name: $channelId, tracks: tracks, audio: true, video: { width: 480 } })
							.then(room => {
								console.log(`Successfully joined a Room: ${room}`);
								activeRoom = room;

								// Log your Client's LocalParticipant in the Room
								const localParticipant = room.localParticipant;
								console.log(`Connected to the Room as LocalParticipant "${localParticipant.identity}"`);

								// Log any Participants already connected to the Room
								room.participants.forEach(participant => {
									console.log(`Participant "${participant.identity}" is connected to the Room`);
									updateParticipantTotal(1, $modalBody)

									var previewContainer = getParticipantContainer($modal, participant.identity);
									participantConnected(participant, previewContainer)

								});

								room.on('participantConnected', participant => {
									console.log(`Participant "${participant.identity}" connected`);

									updateParticipantTotal(1, $modalBody)

									var previewContainer = getParticipantContainer($modal, participant.identity);
									participantConnected(participant, previewContainer)
								});

								room.on('participantDisconnected', participant => {
									console.log(`Participant disconnected: ${participant.identity}`);

									updateParticipantTotal(-1, $modalBody);
									detachParticipant(participant, $modal);
								});

								room.on('disconnected', room => {
									// Detach the local media elements
									console.log(`Disconnected from the Room as LocalParticipant ${room.localParticipant.identity}`);

									if (previewTracks) {
										previewTracks.forEach(function (track) {
											track.stop();
										});
										previewTracks = null;
									}
									detachParticipant(room.localParticipant, $modal);

									room.participants.forEach(participant => {
										detachParticipant(participant, $modal)
									});
									activeRoom = null;
								});
							})
							.catch(error => {
								console.error(`Unable to connect to Room: ${error.message}`);
							});

					});
				}

			}).on('hide.bs.modal', function (event) {
				var $modal = $(this);
				if (activeRoom) {
					activeRoom.disconnect();
				}
			})

			var updateParticipantTotal = function (num, $target) {
				$target.attr('data-total', Number($target.attr('data-total')) + num);
			}

			var getParticipantContainer = function ($target, id) {
				var $div = $target.find(`[data-pid="${id}"]`);
				if (!$div[0]) {
					$div = $(`<div data-pid="${id}"></div>`);
					$target.find('.modal-body').append($div);
				}
				return $div;
			}

			var attachTrack = function (track, container) {
				container.append(track.attach());
			}

			var attachTracks = function (tracks, container) {
				tracks.forEach(function (track) {
					attachTrack(track, container);
				})
			}

			var detachTrack = function (track) {
				track.detach().forEach(function (element) {
					element.remove();
				})
			}

			var trackPublished = function (pub, container) {
				if (pub.isSubscribed) {
					attachTrack(pub.track, container);
				}
				pub.on('subscribed', function (track) {
					attachTrack(track, container);
				})
				pub.on('unsubscribed', detachTrack);
			}

			var trackUnpublished = function (pub) {

			}

			var participantConnected = function (participant, container) {
				participant.tracks.forEach(function (pub) {
					trackPublished(pub, container)
				})
				participant.on('trackSubscribed', function (pub) {
					trackPublished(pub, container)
				})
				participant.on('trackUnsubscribed', trackUnpublished);
			}

			var detachParticipantTracks = function (participant) {
				var tracks = getTracks(participant);
				tracks.forEach(detachTrack);
			}

			var detachParticipant = function (participant, $container) {
				detachParticipantTracks(participant);
				$container.find(`[data-pid="${participant.identity}"]`).remove();
			}

			var getTracks = function (participant) {
				return Array.from(participant.tracks.values()).filter(function (pub) {
					return pub.track;
				}).map(function (pub) {
					return pub.track;
				})
			}

			window.addEventListener('beforeunload', leaveRoomIfJoined);
			var leaveRoomIfJoined = function () {
				if (activeRoom) {
					activeRoom.disconnect();
				}
			}


		}); //end loaded key

		if ($sideBarToggleBtn[0]) {
			$sideBarToggleBtn.on('click', function (e) {
				e.preventDefault();
				if ($sidebar.hasClass('d-x')) {
					$sidebar.removeClass('d-x');
					$sideBarToggleBtn.find('[data-id="show"]').removeClass('d-none');
					$sideBarToggleBtn.find('[data-id="hide"]').addClass('d-none');
					//$sideBarToggleBtn.find('span').text('Hide');
					$mainCol.removeClass('lg-cols-4').addClass('lg-cols-3');
					$content.removeClass('d-flex').addClass('d-none d-sm-flex');
				} else {
					$sidebar.addClass('d-x');
					//$sideBarToggleBtn.find('span').text('Show');
					$sideBarToggleBtn.find('[data-id="hide"]').removeClass('d-none');
					$sideBarToggleBtn.find('[data-id="show"]').addClass('d-none');
					$mainCol.removeClass('lg-cols-3').addClass('lg-cols-4');
					$content.removeClass('d-none').addClass('d-flex');
				}
			});

			if (!$sidebar.is(':visible')) {
				$sidebar.removeClass('d-none').addClass('d-x');
				//$sideBarToggleBtn.find('span').text('Show');
				$sideBarToggleBtn.find('[data-id="hide"]').removeClass('d-none');
				$sideBarToggleBtn.find('[data-id="show"]').addClass('d-none');
				window.scroller.animateScroll($sideBarToggleBtn.offset().top);
			}
		}
	}
};

export default func;
